import { z } from "zod";
import { timestampSchema, uuidSchema } from "./common/primitives.js";
/** Dosya amacı → izin verilen MIME türleri ve azami boyut. Yeni amaç eklenince burada tanımlanır. */
export const FILE_PURPOSES = {
    DOCUMENT: {
        maxBytes: 25 * 1024 * 1024,
        mimeTypes: ["application/pdf", "image/jpeg", "image/png", "image/webp"],
    },
    /** Çek / senet ön ve arka yüz görseli (web ve mobil kamera). */
    INSTRUMENT_IMAGE: {
        maxBytes: 10 * 1024 * 1024,
        mimeTypes: ["image/jpeg", "image/png", "image/webp"],
    },
    /** Gelen e-faturanın ham UBL-TR XML'i ve e-belge görüntüsü (sağlayıcıdan indirilir; kullanıcı yüklemez). */
    EDOCUMENT: {
        maxBytes: 10 * 1024 * 1024,
        mimeTypes: ["application/xml", "text/xml", "application/pdf"],
    },
    IMPORT: {
        maxBytes: 10 * 1024 * 1024,
        mimeTypes: [
            "text/csv",
            "text/plain", // MT940 banka ekstresi (.sta / .txt)
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ],
    },
    /** Prompt 17: sadakat programı logosu (kiracı markası — müşteri uygulaması ve web). */
    BRANDING_IMAGE: {
        maxBytes: 2 * 1024 * 1024,
        mimeTypes: ["image/png", "image/jpeg", "image/webp", "image/svg+xml"],
    },
    /** Prompt 17: imzalı rıza formu / aydınlatma tebliğ kanıtı (KVKK). */
    CONSENT_EVIDENCE: {
        maxBytes: 10 * 1024 * 1024,
        mimeTypes: ["application/pdf", "image/jpeg", "image/png", "image/webp"],
    },
    /** Prompt 17: ilgili kişi başvurusu veri dökümü (sunucu üretir; kullanıcı yüklemez). */
    PRIVACY_EXPORT: {
        maxBytes: 20 * 1024 * 1024,
        mimeTypes: ["application/json"],
    },
    /** Prompt 22: rapor PDF'lerindeki kiracı logosu (pdfkit yalnızca PNG / JPEG gömer). */
    REPORT_LOGO: {
        maxBytes: 1024 * 1024,
        mimeTypes: ["image/png", "image/jpeg"],
    },
    /** Prompt 23: bakım iş emri fotoğrafı (arıza, onarım öncesi / sonrası). Belge ve tutanaklar `DOCUMENT` amacıyla. */
    MAINTENANCE_PHOTO: {
        maxBytes: 10 * 1024 * 1024,
        mimeTypes: ["image/jpeg", "image/png", "image/webp"],
    },
    /** Prompt 18: el yıkama iş emri önce / sonra fotoğrafı (kişisel veri olabilir — saklama süresi sonunda imha). */
    WASH_PHOTO: {
        maxBytes: 10 * 1024 * 1024,
        mimeTypes: ["image/jpeg", "image/png", "image/webp"],
    },
};
export const requestUploadSchema = z.object({
    purpose: z.enum(Object.keys(FILE_PURPOSES)),
    fileName: z.string().trim().min(1).max(255),
    mimeType: z.string().min(3).max(127),
    sizeBytes: z.number().int().positive(),
    sha256: z
        .string()
        .regex(/^[0-9a-f]{64}$/)
        .optional()
        .describe("İstemcinin hesapladığı içerik özeti; onayda doğrulanır"),
    entityType: z.string().max(64).optional(),
    entityId: uuidSchema.optional(),
});
export const uploadTicketSchema = z.object({
    fileId: uuidSchema,
    uploadUrl: z.url().describe("İmzalı PUT adresi"),
    method: z.literal("PUT"),
    headers: z.record(z.string(), z.string()).describe("PUT isteğinde aynen gönderilmesi gereken başlıklar"),
    expiresAt: timestampSchema,
});
export const fileSchema = z.object({
    id: uuidSchema,
    originalName: z.string(),
    mimeType: z.string(),
    sizeBytes: z.string().describe("Bayt (dizge)"),
    sha256: z.string().nullable(),
    status: z.enum(["PENDING", "UPLOADED", "REJECTED"]),
    purpose: z.string(),
    createdAt: timestampSchema,
});
export const downloadLinkSchema = z.object({ url: z.url(), expiresAt: timestampSchema });
export const fileIdParamsSchema = z.object({ id: uuidSchema });
//# sourceMappingURL=files.js.map